import { IBase } from "../base.interface";

// L'ÉTAT D'UN INGRÉDIENT POUR UN RESTAURANT : la rupture est portée par le
// couple ingrédient × restaurant (table `ingredients_shops` du microservice
// catalogue), jamais par la fiche de l'ingrédient elle-même.
export interface IIngredientShop extends Partial<IBase> {
  ingredientId: string;
  shopId: string;
  outOfStock: boolean;
}
